class Enum {
  constructor(key, name) {
    this.Key = key;
    this.Name = name;
  }
}

export default Enum;



// WEBPACK FOOTER //
// ./src/Stores/DataStore/Enums/Enum.js